/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockVaultConnector } from "../MockVaultConnector";

export class MockVaultConnector__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _save: string,
    _mUSD: string,
    overrides?: Overrides
  ): Promise<MockVaultConnector> {
    return super.deploy(
      _save,
      _mUSD,
      overrides || {}
    ) as Promise<MockVaultConnector>;
  }
  getDeployTransaction(
    _save: string,
    _mUSD: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_save, _mUSD, overrides || {});
  }
  attach(address: string): MockVaultConnector {
    return super.attach(address) as MockVaultConnector;
  }
  connect(signer: Signer): MockVaultConnector__factory {
    return super.connect(signer) as MockVaultConnector__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockVaultConnector {
    return new Contract(address, _abi, signerOrProvider) as MockVaultConnector;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_save",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mUSD",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "checkBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "poke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5060405161069d38038061069d83398101604081905261002f9161007c565b600080546001600160a01b039384166001600160a01b031991821617909155600180549290931691161790556100ae565b80516001600160a01b038116811461007757600080fd5b919050565b6000806040838503121561008e578182fd5b61009783610060565b91506100a560208401610060565b90509250929050565b6105e0806100bd6000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c8063181783581461005c5780632e1a7d4d14610066578063853828b614610079578063b6b55f2514610081578063c71daccb14610094575b600080fd5b6100646100ae565b005b6100646100743660046104d7565b610122565b61006461029c565b61006461008f3660046104d7565b610389565b61009c610485565b60405190815260200160405180910390f35b60045442901561011d576000600454826100c8919061057d565b905060006100db6407620d06ef8361055e565b90506000670de0b6b3a7640000826003546100f6919061055e565b610100919061053e565b905080600360008282546101149190610526565b90915550505050505b600455565b6000546001600160a01b031633146101555760405162461bcd60e51b815260040161014c906104ef565b60405180910390fd5b600061015f610494565b905061016b828261057d565b60025560015460005460405163a9059cbb60e01b81526001600160a01b0391821660048201526024810185905291169063a9059cbb90604401602060405180830381600087803b1580156101be57600080fd5b505af11580156101d2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101f691906104b0565b506103e8610206836103ed61055e565b610210919061053e565b60036000828254610221919061057d565b90915550506004544291501561029657600060045482610241919061057d565b905060006102546407620d06ef8361055e565b90506000670de0b6b3a76400008260035461026f919061055e565b610279919061053e565b9050806003600082825461028d9190610526565b90915550505050505b60045550565b6000546001600160a01b031633146102c65760405162461bcd60e51b815260040161014c906104ef565b60006002819055600154905460035460405163a9059cbb60e01b81526001600160a01b039283166004820152602481019190915291169063a9059cbb90604401602060405180830381600087803b15801561032057600080fd5b505af1158015610334573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061035891906104b0565b506003805490600061036a838061057d565b909155505060045442901561011d576000600454826100c8919061057d565b6000546001600160a01b031633146103b35760405162461bcd60e51b815260040161014c906104ef565b60006103bd610494565b90506103c98282610526565b6002556001546000546040516323b872dd60e01b81526001600160a01b039182166004820152306024820152604481018590529116906323b872dd90606401602060405180830381600087803b15801561042257600080fd5b505af1158015610436573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061045a91906104b0565b506103e861046a836103e361055e565b610474919061053e565b600360008282546102219190610526565b600061048f610494565b905090565b6000600354600254116104a95760035461048f565b5060025490565b6000602082840312156104c1578081fd5b815180151581146104d0578182fd5b9392505050565b6000602082840312156104e8578081fd5b5035919050565b60208082526017908201527f4f6e6c7920534156452063616e2063616c6c2074686973000000000000000000604082015260600190565b6000821982111561053957610539610594565b500190565b60008261055957634e487b7160e01b81526012600452602481fd5b500490565b600081600019048311821515161561057857610578610594565b500290565b60008282101561058f5761058f610594565b500390565b634e487b7160e01b600052601160045260246000fdfea2646970667358221220a50a58da8999a752005f1522a3026fc93d934db02c840511b872c976d920fc0a64736f6c63430008020033";
